var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9415 0 36 8.05852 36 18C36 27.9415 27.9415 36 18 36C8.05852 36 0 27.9415 0 18C0 8.05852 8.05852 0 18 0Z",
    fill: "#69A6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 11.7988C27.2562 12.125 26.4637 12.3412 25.6375 12.4462C26.4875 11.9387 27.1363 11.1412 27.4413 10.18C26.6488 10.6525 25.7737 10.9863 24.8412 11.1725C24.0887 10.3713 23.0162 9.875 21.8462 9.875C19.5762 9.875 17.7487 11.7175 17.7487 13.9763C17.7487 14.3013 17.7762 14.6137 17.8438 14.9112C14.435 14.745 11.4188 13.1113 9.3925 10.6225C9.03875 11.2363 8.83125 11.9388 8.83125 12.695C8.83125 14.115 9.5625 15.3737 10.6525 16.1025C9.99375 16.09 9.3475 15.8988 8.8 15.5975C8.8 15.61 8.8 15.6262 8.8 15.6425C8.8 17.635 10.2212 19.29 12.085 19.6712C11.7512 19.7625 11.3875 19.8062 11.01 19.8062C10.7475 19.8062 10.4825 19.7912 10.2337 19.7362C10.765 21.36 12.2725 22.5537 14.065 22.5925C12.67 23.6837 10.8988 24.3412 8.98125 24.3412C8.645 24.3412 8.3225 24.3262 8 24.285C9.81625 25.4562 11.9688 26.125 14.29 26.125C21.835 26.125 25.96 19.875 25.96 14.4575C25.96 14.2762 25.9537 14.1013 25.945 13.9275C26.7587 13.35 27.4425 12.6288 28 11.7988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d6b8276f35fcb5ee3cd3af16c372e3ec.svg";
export { ForwardRef as ReactComponent };